// src/components/dashboard/TryThisWeek.jsx
//
// One thing to try this week: one of the "This week" practices from the
// summary of the module you finished most recently, the same one all week.
// The words are the module's own (summary.nextSteps.practices); nothing is
// written for this card. There is nothing to tick off and nothing to report
// back: it's there to be tried, or not.
import React, { useMemo } from 'react';
import { Repeat } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../shared/CardComponents';
import { friendshipModules } from '../../data/modules/friendship-modules-index';
import { formatInline } from '../modules/renderer/inlineMarkdown';
import { pickPracticeForWeek } from '../../utils/dashboardPlan';

const TryThisWeek = ({ completedModules = [], moduleCompletedAt = {}, now }) => {
  const pick = useMemo(
    () => pickPracticeForWeek({
      modules: friendshipModules,
      completedModules,
      moduleCompletedAt,
      now: now || new Date(),
    }),
    [completedModules, moduleCompletedAt, now],
  );

  return (
    <Card className="bg-gradient-to-br from-emerald-500/10 to-teal-500/10 border-emerald-500/30" data-testid="try-this-week">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-white text-lg">
          <Repeat className="w-5 h-5 text-emerald-400" aria-hidden="true" />
          One thing to try this week
        </CardTitle>
      </CardHeader>
      <CardContent>
        {pick ? (
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-white">{pick.practice.title}</h3>
            <p className="text-slate-300 leading-relaxed">{formatInline(pick.practice.description)}</p>
            <p className="text-xs text-slate-400">
              From Module {pick.module.id}, {pick.module.title}
              {pick.practice.duration ? ` · ${pick.practice.duration}` : ''}
            </p>
          </div>
        ) : (
          <p className="text-slate-300 leading-relaxed">
            Each module ends with a few small things to try in real life. When you finish one, one of
            them will sit here for the week.
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default TryThisWeek;
